import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import PodcastsDetail from '@/components/screens/podcasts-detail/PodcastsDetail';
import { API_URL } from '@/helpers/variables';
import { IPodcastsDetailData } from '@/interfaces/podcastsDetail.interface';
import { IReviews } from '@/interfaces/reviews.interface';
import { IQuotes } from '@/interfaces/quotes.interface';

interface IPodcastsDetailPage {
  book: IPodcastsDetailData;
  reviews: IReviews;
  quotes: IQuotes;
}

const PodcastsDetailPage: NextPage<IPodcastsDetailPage> = ({ book, reviews, quotes }) => {
  return <PodcastsDetail book={book} reviews={reviews} quotes={quotes} isPodcastsPage={true} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { podcastsAlias } = context.query;

  const aliasFragments = String(podcastsAlias)?.split('-');
  const bookId = aliasFragments[aliasFragments.length - 1];

  const [bookRes, reviewsRes, quotesRes] = await Promise.all([
    fetch(`${API_URL}satellite/podcast/podcast/${podcastsAlias}`),
    fetch(`${API_URL}satellite/reviews/?book_alias=${podcastsAlias}&page=1&page_size=5`),
    fetch(`${API_URL}satellite/quotes/?book_id=${bookId}&page=1&page_size=5`),
  ]);
  const [book, reviews, quotes] = await Promise.all([bookRes.json(), reviewsRes.json(), quotesRes.json()]);

  // Check Fetched Data Error
  if (!book.id) {
    return {
      notFound: true,
    };
  }

  return { props: { book, reviews, quotes } };
};

export default PodcastsDetailPage;
